import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["options", "required", "error", "labelPlacement", "row", "formControlLabel"],
    _excluded2 = ["labelPlacement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, FormControlLabel, FormHelperText, Radio, RadioGroup } from '@mui/material';
import { Controller } from 'react-hook-form';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RadioGroupFormBase = function RadioGroupFormBase(_ref) {
  var options = _ref.options,
      required = _ref.required,
      error = _ref.error,
      labelPlacement = _ref.labelPlacement,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? false : _ref$row,
      formControlLabel = _ref.formControlLabel,
      controllerProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(Box, {
    "data-element": "Box",
    "data-component": "RadioGroupFormBase",
    "data-source-file": "radio-group-form-field.tsx",
    children: [/*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({}, controllerProps), {}, {
      rules: _objectSpread(_objectSpread({}, controllerProps.rules), {}, {
        required: required
      }),
      render: function render(_ref2) {
        var field = _ref2.field;
        return /*#__PURE__*/_jsx(RadioGroup, _objectSpread(_objectSpread({
          sx: {
            my: -0.75
          }
        }, field), {}, {
          row: row,
          "aria-label": "number",
          children: options.map(formControlLabel)
        }));
      },
      "data-element": "Controller",
      "data-component": "RadioGroupFormBase",
      "data-source-file": "radio-group-form-field.tsx"
    })), error && /*#__PURE__*/_jsx(FormHelperText, {
      sx: {
        mt: 1,
        ml: 0,
        color: function color(theme) {
          return theme.palette.error.main;
        }
      },
      children: /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return t('This field is required.');
        }
      })
    })]
  });
};

var RadioGroupFormField = function RadioGroupFormField(_ref3) {
  var labelPlacement = _ref3.labelPlacement,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/_jsx(RadioGroupFormBase, _objectSpread(_objectSpread({}, props), {}, {
    labelPlacement: labelPlacement,
    formControlLabel: function formControlLabel(option, index) {
      var _option$label;

      return /*#__PURE__*/_jsx(FormControlLabel, {
        sx: {
          m: 0
        },
        value: option.value,
        control: /*#__PURE__*/_jsx(Radio, {
          sx: {
            p: 0.5,
            mx: 0.5
          }
        }),
        label: (_option$label = option.label) !== null && _option$label !== void 0 ? _option$label : option.value,
        labelPlacement: labelPlacement
      }, index);
    },
    "data-element": "RadioGroupFormBase",
    "data-component": "RadioGroupFormField",
    "data-source-file": "radio-group-form-field.tsx"
  }));
};

export default RadioGroupFormField;